// Tiny module-level event bus so the axios interceptor (non-React)
// can notify the React-side NetworkStatusProvider.
const listeners = new Set();

export const networkBus = {
  emit(payload) {
    listeners.forEach((fn) => {
      try {
        fn(payload);
      } catch (e) {
        // swallow listener errors — they must never block the bus
        console.warn("networkBus listener error:", e);
      }
    });
  },
  subscribe(fn) {
    listeners.add(fn);
    return () => listeners.delete(fn);
  },
};

// Returns true if the axios error looks like a connectivity / unreachable-server failure.
export const isNetworkError = (error) => {
  if (!error) return false;
  if (typeof navigator !== "undefined" && navigator.onLine === false) return true;
  if (error.code === "ERR_NETWORK") return true;
  if (error.code === "ECONNABORTED") return true; // timeout
  if (error.message === "Network Error") return true;
  // axios resolves "no response" when the request never reached the server
  if (!error.response && error.request) return true;
  return false;
};
